import { z } from 'zod'
import { sponsorLocaleSchema } from './sponsor.schema'

// Spec PWA-014 D-01/D-03 — avisos do padrinho (Web Push). Copia da validacao do partner-app (PARTNER-002 / ADMIN-002 D-03),
// com o idioma do aparelho (D-04): o aviso sai no idioma do app naquele aparelho.

/** So servicos de push conhecidos (o servidor nao chama enderecos quaisquer). */
const PUSH_HOSTS = [/^fcm\.googleapis\.com$/, /\.push\.services\.mozilla\.com$/, /\.push\.apple\.com$/, /\.notify\.windows\.com$/]

export function isPushEndpoint(value: string): boolean {
    let url: URL
    try {
        url = new URL(value)
    } catch {
        return false
    }
    return url.protocol === 'https:' && url.port === '' && !url.username && !url.password && PUSH_HOSTS.some(host => host.test(url.hostname))
}

export const sponsorPushEndpointSchema = z.string().max(2048).refine(isPushEndpoint)

/** Como o navegador entrega (PushSubscription.toJSON): p256dh = ponto P-256 de 65 bytes (comeca com 0x04 → "B"),
    auth = 16 bytes, os dois em base64url sem preenchimento. */
export const sponsorPushKeysSchema = z.object({
    p256dh: z.string().regex(/^B[A-Za-z0-9_-]{86}$/),
    auth: z.string().regex(/^[A-Za-z0-9_-]{21}[AQgw]$/),
})

/** PUT /push/subscriptions — ligar os avisos (ou atualizar o idioma) neste aparelho. */
export const sponsorPushSubscriptionSchema = z.object({
    endpoint: sponsorPushEndpointSchema,
    keys: sponsorPushKeysSchema,
    locale: sponsorLocaleSchema,
})
export type SponsorPushSubscriptionInput = z.infer<typeof sponsorPushSubscriptionSchema>

/** DELETE /push/subscriptions e POST /push/test — so o endereco do aparelho. */
export const sponsorPushEndpointBodySchema = z.object({ endpoint: sponsorPushEndpointSchema })

/** GET /push/config — enabled: o servidor tem as chaves; publicKey: chave VAPID publica para o navegador. */
export const sponsorPushConfigSchema = z.object({
    enabled: z.boolean(),
    publicKey: z.string().nullable(),
}).strict()
export type SponsorPushConfig = z.infer<typeof sponsorPushConfigSchema>
